import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import TokenChecker from "services/TokenChecker";
import { selectLoading } from "state/slices/loaderSlice";
import Footer from "./Footer";
import Header from "./Header";

function Layout() {
  const location = useLocation();
  const isLoginPage =
    location.pathname === "/" ||
    location.pathname === "/login" ||
    location.pathname === "/sign-in" ||
    location.pathname === "/404";
  const isLoading = useSelector(selectLoading);

  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <TokenChecker />
      <Header />
      <div style={{ flex: "1" }}>
        <Outlet />
      </div>
      {!isLoginPage && !isLoading && <Footer />}
    </div>
  );
}

export default Layout;
